//import { logo1881 } from "assets/img";


const LoadingScreen = ():JSX.Element => {
  let loadingRobot = require("assets/img/loading.gif")
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-6 offset-md-3">
            <div className="d-flex justify-content-center mt-4">
                <div className="d-block">
                    {/* <p><img src={logo1881} alt="1881 Logo" width="250px" /></p> */}
                    <p><img src={loadingRobot} className="img-fluid rounded-circle" alt="Loading content" /></p>
                    {/* <div className="text-center">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <span className="ps-3">Loading...</span>
                    </div> */}
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
